import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

import ScribeHeader from './ScribeHeader';
import {
  clearScribeConversationState,
  exitScribeMode,
  firebaseLogout,
  getTranscriptHtml,
  getTranscriptText,
  switchPlatform,
  switchWebProduct,
  toggleSideBar,
  updateFullScreen,
} from '../../actions';

const mapStateToProps = ({
  scribeConversation: {
    conversationEnded,
    conversationStarted,
    inTwilioCalls,
    scribe,
    speakerListened,
    speakers,
    status,
  },
  firebase: {
    user: firebaseUser,
  },
  scribeSession: {
    backends,
    captioner,
    currentPlatform,
    displayable,
    features,
    intercomDisplayed,
    lightView,
    mirror,
    scribeDashboard,
    sidebar,
    v1,
  },
  scribeTranscriptUI: { fullScreen, displayShortcuts, electronCaptionMode },
}) => ({
  backends,
  conversationEnded,
  conversationStarted,
  currentPlatform,
  displayShortcuts,
  displayable,
  features,
  firebaseUser,
  fullScreen,
  electronCaptionMode,
  inTwilioCalls,
  intercomDisplayed,
  lightView,
  mirror,
  scribe,
  scribeDashboard,
  sidebar,
  speakerListened,
  speakers,
  status,
  user: captioner,
  v1,
});

export default withSnackbar(
  connect(
    mapStateToProps,
    {
      clearScribeConversationState,
      exitScribeMode,
      firebaseLogout,
      getTranscriptHtml,
      getTranscriptText,
      switchPlatform,
      switchWebProduct,
      toggleSideBar,
      updateFullScreen,
    }
  )(ScribeHeader)
);
